import React from 'react';
import './Footer.css'
import {useLocation} from 'react-router-dom'


function Footer() {

  const location = useLocation();

  const backgroundColor = location.pathname === '/login' || location.pathname === '/register' ? 'rgba(0, 0, 0, 0)' : 'rgba(255, 255, 255, 1)'; // Transparent black (0 opacity)

  const footerstyle = {
    "backgroundColor": backgroundColor, 
  };
  return (
      <div className="container" style={footerstyle}>
        <center>
          <span >© {new Date().getFullYear()} Jackpot - Mens Wear</span>
        </center>
      </div>
  );
}

export default Footer;
